export default __webpack_public_path__ + "static/media/40.7d0cf88b.svg";